var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "feed-manager__page-base" },
    [
      _c(
        _vm.component,
        _vm._b(
          {
            tag: "component",
            on: {
              createFeed: _vm.openFeedModal,
              editFeed: _vm.editFeed,
              editSchedule: _vm.editSchedule,
              scheduleFeed: _vm.openFrequencyModal,
              deleteFeed: _vm.deleteFeed,
              deleteSchedule: _vm.deleteSchedule,
              downloadSchedule: _vm.downloadSchedule,
              export: _vm.runFeed,
              clickedRow: _vm.onRowClick,
              refresh: _vm.refresh,
            },
          },
          "component",
          _vm.pageProperties,
          false
        )
      ),
      _vm._v(" "),
      _vm.showConfirmDialog
        ? _c("ConfirmDialog", {
            attrs: {
              visible: _vm.showConfirmDialog,
              list: _vm.scheduleList,
              tableType: _vm.view,
              "is-feed-running": _vm.isFeedRunning,
            },
            on: {
              confirmDeleteFeed: _vm.confirmDeleteFeedAction,
              confirmDeleteSchedule: _vm.confirmDeleteScheduleAction,
              close: function ($event) {
                _vm.showConfirmDialog = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSchedulerModal
        ? _c("scheduler-modal", {
            ref: "modal",
            attrs: {
              "show-scheduler-modal": _vm.showSchedulerModal,
              "notebooks-provider": _vm.notebooksProvider,
            },
            on: { close: _vm.closeFeedModal },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFrequencyModal
        ? _c("frequency-modal", {
            attrs: {
              showFrequencyModal: _vm.showFrequencyModal,
              "modal-loading": _vm.frequencyModalLoading,
              "save-schedule-response": _vm.saveScheduleResponse,
              "save-schedule-status": _vm.saveScheduleStatus,
              "has-duplicate-name": _vm.hasDuplicateName,
              "feed-id": _vm.feedId,
            },
            on: {
              createSchedule: _vm.createSchedule,
              close: _vm.closeModal,
              "hide-feedback-message": _vm.renameSchedule,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFlyover
        ? _c("flyover", {
            staticClass: "feed-manager__flyover",
            class: { "feed-manager__flyover--open": _vm.showFlyover },
            attrs: {
              "flyover-tabs": _vm.flyoverTabs,
              "selected-row-info": _vm.selectedRowInfo,
              "show-flyover": _vm.showFlyover,
              "loading-flyover": _vm.loadingFlyover,
              view: _vm.view,
              "flyover-provider": _vm.flyoverProvider,
              "reload-schedules-tab": _vm.reloadSchedules && _vm.saveSchedule,
            },
            on: {
              closeFlyover: function ($event) {
                _vm.showFlyover = false
              },
              scheduleFeed: _vm.openFrequencyModal,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }